/* eslint-disable */
import React, { useEffect, useState } from 'react'
import 'antd/dist/antd.css'

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
// import { history } from 'redux/store';
import { connect, useDispatch, useSelector } from 'react-redux'
import { Layout, Menu, Row, Col, Select, Dropdown, Spin, message } from 'antd';
import userIconImage from 'images/icon-memberwhite.svg'
import { GetLoginRedirect, logout, refreshToken } from 'api/hub'
import Navbar from './Navbar';
import moment from "moment";
import { useHistory } from "react-router-dom";


const { Header } = Layout
const { Option } = Select
const navigation = [
  { name: 'Dashboard', href: '#', current: true },
  { name: 'Team', href: '#', current: false },
  { name: 'Projects', href: '#', current: false },
  { name: 'Calendar', href: '#', current: false },
]
// React Function Component Es6寫法
const PageHeader = (props, { component: Component, store, ...rest }) => {

  const { i18n, t } = useTranslation()
  const dispatch = useDispatch()
  let history = useHistory();
  const [loading, setLoading] = useState(false)
  useEffect(()=>{
    if(localStorage.getItem('lang') === null){
      var lang = navigator.language || navigator.userLanguage;
      if(lang ==='zh-TW' || lang ==='zh-CN' || lang === 'zh-HK'){
        lang='tw'
      }else{
        lang='en'
      }
      localStorage.setItem('lang',lang)
    } else {
      i18n.changeLanguage(localStorage.getItem('lang'))
    }
  }, [])

  // redux use selector
  // const loginInfo = useSelector(state => state.LoginInfo)
  // redux store => LoginInfo的資料

  // const LoginInfo = JSON.parse(localStorage.getItem('LoginInfo'))
  const LoginInfo = null
  // i18n.changeLanguage(localStorage.getItem('lang'))
  // useEffect(() =>{
  //   if( moment().diff(JSON.parse(localStorage.getItem('expiresIn'))) > 0 ){
  //     dispatch(refreshToken({ refresh_token: JSON.parse(localStorage.getItem('refresh_token'))})).then(resp =>{
  //       if(resp.code ===200 ){
  //         let temp = JSON.parse(localStorage.getItem('LoginInfo'))

  //         temp.accessToken = resp.data.access_token
  //         localStorage.setItem('expiresIn', JSON.stringify(moment().utc().add(8, 'hours').add(1, 'minutes').format('YYYY-MM-DD HH:mm:ss')))
  //         localStorage.setItem('refresh_token', JSON.stringify(resp.data.refresh_token))
  //         localStorage.setItem('LoginInfo', JSON.stringify(temp))
  //       }else{
  //           localStorage.removeItem('LoginInfo')
  //           localStorage.removeItem('expiresIn')
  //           localStorage.removeItem('refresh_token')
  //           sessionStorage.clear()
  //           history.push("/")
  //           setTimeout(() => {
  //             message.success(t('Global.TokenTimeout'))
  //             }, 0);
  //       }
  //     })
  //   }
  // }, [dispatch, window.location.pathname])

  const handleLogin = (values) => {
    setLoading(true)
    if(process.env.REACT_APP_ENV === "development"){
      dispatch(GetLoginRedirect({request:'http://localhost:3000/auth/login'})).then(res=>{
        setLoading(false)
        if(res){
          if(res.code === 200) {
            window.location.href=res.data
          }
        }
        })
      }else{
        dispatch(GetLoginRedirect()).then(res=>{
          setLoading(false)
          if(res){
            if(res.code === 200) {
              window.location.href=res.data
            }
          }
          })
      }
  }

  const handleLangChange = () => {
    if (value && value !== null) {
      localStorage.setItem('lang',value)
      i18n.changeLanguage(value)
    }
  }

  const handleLogout = () => {
    setLoading(true)
    dispatch(logout({
      "access_token": LoginInfo.accessToken
    })).then(res=>{
      setLoading(false)
      console.log(res)
 
      localStorage.removeItem('LoginInfo')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('expiresIn')
      localStorage.removeItem('AppRefreshToken')
      window.location.href='/'
      
    })
  
  }

  const menu = (
    <Menu>
      <Menu.Item key="0">
        <a rel="noopener noreferrer" href="/portal/service">
          {t('Header.MemberCenter')}
        </a>
      </Menu.Item>
      <Menu.Item key="1">
        <a rel="noopener noreferrer" href="/portal/account/setting/user">
          {t('Header.MyAccount')}
        </a>
      </Menu.Item>
      <Menu.Item key="4">
        <a rel="noopener noreferrer" href="/portal/account/password">
          {t('Header.ChangePassword')}
        </a>
      </Menu.Item> 
      <Menu.Divider />
      <Menu.Item key="4" >
        <Link to='/auth/login' onClick={handleLogout}>{t('Header.SignOut')}</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    // <Spin tip={t('Global.Loading')} spinning={loading} style={{padding: '36px 0 0 130px'}}>
    // <Layout className='headerlayout'>
    //   <Header style = {{ zIndex: 1, width: '100%',margin: '0px auto'}}>
    //     <Row justify='space-between'>
    //       <Col span={12}>
    //       <div className='logo' onClick={()=>{window.location.href="/"}}>
    //         <a style={{ color: '#7DB926'}}>WiAdvance App Market</a>
    //       </div>
    //       <div className='logo' onClick={()=>{window.location.href="/"}}>
    //         <a style={{ color: '#7D7D7D', fontWeight: '400', fontSize: '16px' }}>關於</a>
    //       </div>
    //       <div className='logo' onClick={()=>{window.location.href="/"}}>
    //         <a style={{ color: '#7D7D7D', fontWeight: '400', fontSize: '16px' }}>類別</a>
    //       </div>
    //       <div className='logo' onClick={()=>{window.location.href="/"}}>
    //         <a style={{ color: '#7D7D7D', fontWeight: '400', fontSize: '16px' }}>產業</a>
    //       </div>
    //       <Col>
    //       </Col>
    //       </Col>
    //       <Col span={6}>
    //         <Row justify='end' align='middle'>
    //           <Col span={6}>
    //             <Row justify='center'>
    //               <Col>
    //                 <div style={{ color: '#000000', display: 'flex' }}>
    //                   {/* <span style={{ fontSize: 11 }}>{ LoginInfo ? `${LoginInfo.userName}`  : ''}</span> */}
    //                   {/* <span style={{ fontSize: 10, paddingLeft: 10 }}>{ LoginInfo ? LoginInfo.account : ''}</span>  */}
    //                 </div>
    //               </Col>
    //             </Row>
    //           </Col>
    //           <Col span={6}>
    //           <Select value={localStorage.getItem('lang') ? localStorage.getItem('lang'): i18n.language} style={{ width: 120, right:100 }} onChange={handleLangChange}>
    //               {/* onChange={handleChange} */}
    //               <Option value='tw'>{t('Global.Chinese')}</Option>
    //               <Option value='en'>{t('Global.English')}</Option>
    //           </Select>
    //           </Col>
    //           <Col span={12}>
    //             {
    //               LoginInfo === null ?
    //               <><a style={{ color: '#82C200', paddingRight: 20, fontWeight: 'bold' }} onClick={handleLogin}>{t('Header.login')}</a><span className="navbar__link-separator">|</span><Link style={{ color: '#7C7C7C', paddingLeft: 20, fontWeight: 'bold' }} to='/Register/Agreement'>{t('Header.sign_up')}</Link></> :
    //               <>
    //               <Row>
    //               <Dropdown overlay={menu} trigger={['click']}>
    //                 <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
    //                   <span className="headertext">{LoginInfo.userName}</span>
                      
    //                     {
    //                       LoginInfo.profilePhoto?
    //                       <div className='headerprofileW'>
    //                         <img className='photo' alt='user' src={LoginInfo.profilePhoto}/>
    //                       </div>:
    //                       <div className='headerprofile'>
    //                         <img className='user' alt='user icon' src={userIconImage}></img>
    //                       </div>
    //                     }
    //                 </a>
    //               </Dropdown>
                  
    //                 </Row>
    //               </>
    //             }
    //           </Col>
    //         </Row>
    //       </Col>
    //     </Row>
    //   </Header>
    // </Layout>
    // </Spin>
    <Navbar></Navbar>
    )
  }

export default (PageHeader)
